var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "construction-content" }, [
    _c(
      "div",
      { staticClass: "row border-radius bg-white padding-flex mb-1" },
      [
        _vm._t("title"),
        _vm._v(" "),
        _c("div", { class: _vm.$root.is_mobile ? "text-left" : "text-right" }, [
          _c(
            "a",
            {
              staticClass: "print-pdf",
              attrs: { href: _vm.estate.pdf, target: "_blank", rel: "nofollow" }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.trans("labels.print")) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _vm.estate.specifications
            ? _c(
                "a",
                {
                  staticClass: "print-pdf",
                  attrs: { href: _vm.estate.specifications, target: "_blank" }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.trans("labels.specifications")) +
                      "\n            "
                  )
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "estate-description" },
          [_vm._t("description")],
          2
        ),
        _vm._v(" "),
        _vm.estate.solutions
          ? _c("construction-solutions", {
              attrs: { estate: _vm.estate, solutions: _vm.estate.solutions }
            })
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }